module.exports = __webpack_public_path__ + "img/defaultcharacter.82bd6fd7.png";